<template>
  <div :class="{ 'isDark': darkmode }">
    <div v-if="mGPS.type">
      <i v-if="mGPS.status === 'offline'" class="fas fa-times-circle" style="color: #dc3545" />
      <i v-else-if="mGPS.status === 'unknown'" class="fas fa-mobile-alt" style="color: #ffc107" />
      <i v-else class="fas fa-mobile-alt" style="color: #009f5c" />
      mGPS
    </div>
    <div v-else-if="!isPowerOn">
      <i class="fas fa-power-off" style="color: #dc3545" />
      {{ isPowerOn ? '' : 'OFF' }}
    </div>
    <div v-else>
      <i v-if="batteryLevel > 90" class="fas fa-battery-full fa-rotate-270" :style="`color: ${powerColor};`"></i>
      <i v-else-if="batteryLevel > 60" class="fas fa-battery-three-quarters fa-rotate-270"
        :style="`color: ${powerColor};`"></i>
      <i v-else-if="batteryLevel > 25" class="fas fa-battery-half fa-rotate-270" :style="`color: ${powerColor};`"></i>
      <i v-else-if="batteryLevel > 5" class="fas fa-battery-quarter fa-rotate-270" :style="`color: ${powerColor};`"></i>
      <i v-else class="fas fa-battery-empty fa-rotate-270" :style="`color: ${powerColor};`"></i>

      {{ `${batteryLevel}%` || '??' }}

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    darkmode: {
      type: Boolean,
    },
    device: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      oldBatteryLevel: 0
    }
  },
  computed: {
    ...mapGetters([
      'positions',
      'devices'
    ]),
    mGPS() {
      return {
        type: this.positions[this.device].protocol === 'osmand' || false,
        status: this.devices[this.device].status || null
      }
    },
    batteryLevel() {
      if (this.positions[this.device].attributes.batteryLevel) {
        return this.positions[this.device].attributes.batteryLevel
      }
      return this.oldBatteryLevel
    },
    powerColor() {
      if (this.batteryLevel > 50) {
        return `#058011` // green success
      } else if (this.batteryLevel > 15) {
        return `#f99b62` // yellow warning
      } else
        return `#dc3545` // red danger
    },
    isPowerOn() {
      return this.positions[this.device].attributes.alarm != "powerOff"
    },
  },
  watch: {
    batteryLevel(newValue, oldValue) {
      if (oldValue !== newValue) {
        this.oldBatteryLevel = newValue
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.isDark {
  text-shadow: 0 0 5px #000, 0 0 5px #000, 0 0 5px #000, 0 0 5px #000;
}
</style>